// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

// export function box15_mouseIn(event) {
// 	//$w("#box15").style.borderWidth = "1px";
// }

// export function box15_mouseOut(event) {
// 	//$w("#box15").style.borderWidth = "0px"; 
// }
